export const meetingsSchema = {
	schema: {
		title: 'Meetings schema',
		description: 'create a Meetings schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			app_id_c: {
				type: 'string',
			},
			name: {
				type: 'string',
			},
			meeting_type_c: {
				type: 'string',
			},
			startdate: {
				type: 'string',
				format: 'date-time',
			},
			enddate: {
				type: 'string',
				format: 'date-time',
			},
			start_time_c: {
				type: 'string',
				format: 'time',
			},
			end_time_c: {
				type: 'string',
				format: 'time',
			},
			town_venue_c: {
				type: 'string',
			},
			venue_town_name_c: {
				type: 'string',
			},
			status: {
				type: 'string',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
			lastmodifieddate: {
				type: 'string',
				format: 'date-time',
			},
		},
		required: [
			'id',
			'sfid',
			'app_id_c',
			'name',
			'meeting_type_c',
			'startdate',
			'enddate',
			'start_time_c',
			'end_time_c',
			'town_venue_c',
			'venue_town_name_c',
			'status',
			'createddate',
			'lastmodifieddate',
		],
	},
};
